import { createAsyncThunk } from '@reduxjs/toolkit';
import type { FetchResponse } from '@cian/http-api';
import { IThunkApi } from '../../types/redux';
import { fetchPublicMyHomeV1GetGeocode } from '../../../common/repositories/newbuilding-estimate/my-home/v1/get-geocode';
import type { TPublicMyHomeV1GetGeocodeResponse } from '../../../common/repositories/newbuilding-estimate/my-home/v1/get-geocode/types';
import { isEmpty } from '../../utils/isEmpty';
import {
  setIsNebuilding,
  setNewbuildingInfo,
  setNewbuildingSectionsList,
  setNewbuildingSection,
  resetNewbuildingState,
} from '../../slices';

import { getFlatAreasSuggest } from '../getFlatAreasSuggest';

import { newbuildingSectionsListMapper } from './mappers/newbuildingSectionsListMapper';

export const getGeocode = createAsyncThunk<void, string, IThunkApi>('getGeocode', async (address, _thunkApi) => {
  const {
    extra: { httpApi, logger },
    dispatch,
  } = _thunkApi;

  return fetchPublicMyHomeV1GetGeocode({
    httpApi,
    parameters: {
      address,
    },
  })
    .then(rawResponse => {
      const response = rawResponse as FetchResponse<TPublicMyHomeV1GetGeocodeResponse>;

      if (response.statusCode === 200) {
        const { newbuilding, newbuildingHouses, selectedHouseIndex } = response.response;

        if (newbuilding && !isEmpty(newbuilding)) {
          dispatch(setIsNebuilding(true));
          dispatch(setNewbuildingInfo(newbuilding));

          if (selectedHouseIndex !== undefined) {
            dispatch(setNewbuildingSection(newbuildingHouses[selectedHouseIndex as number].id));
            dispatch(setNewbuildingSectionsList(newbuildingSectionsListMapper(newbuildingHouses)));
          }
        } else {
          dispatch(resetNewbuildingState());
          dispatch(getFlatAreasSuggest(address));
        }
      }

      return Promise.reject(response);
    })
    .catch(response => {
      logger.error(response);
    });
});
